import React from "react";
import { Link } from "react-router-dom";  
import Cards2 from "../cards/Cards2";
import Charts from "../charts/Charts";

const Home = () => {
  return (
    <>
      <section
        className="home bg-cover bg-center min-h-screen"
        style={{
          backgroundImage: "url('/assets/images/power.jpg')",
        }}
      >
        <div className="container mx-auto px-4 py-10">

          {/* Home Button - adjusted position and size */}
          <a 
            href="https://securegate.slt.lk/adminLandingPage" 
            className="fixed bottom-16 right-8 z-10 flex items-center group"
          >
            <div className="flex items-center justify-center w-14 h-14 rounded-full bg-white bg-opacity-20 backdrop-blur-md group-hover:bg-opacity-30 transition-all duration-300 shadow-lg hover:shadow-xl border border-white border-opacity-30">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-9 w-9 text-white group-hover:scale-110 transition-transform duration-200" 
                viewBox="0 0 20 20" 
                fill="currentColor"
              >
                <path d="M10.707 1.293a1 1 0 00-1.414 0l-7 7A1 1 0 003 9h1v7a2 2 0 002 2h3v-5h2v5h3a2 2 0 002-2V9h1a1 1 0 00.707-1.707l-7-7z" />
              </svg>
            </div>
            <span className="ml-2 text-sm text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              Home
            </span>
          </a>

          <div className="flex flex-col md:flex-row justify-between items-center mb-8 pt-6">
            <h3 className="text-3xl font-semibold text-white drop-shadow">Dashboard</h3>

            <div className="flex space-x-4 mt-4 md:mt-0">
              <Link 
                to="/singlephase" 
                className="px-6 py-2 
                  border border-[#005BAC] 
                  bg-[#005BAC] 
                  text-white 
                  rounded-md 
                  transition duration-300 
                  hover:bg-white 
                  hover:text-[#005BAC] 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-[#005BAC] 
                  focus:ring-opacity-50"
              >
                Single Phase
              </Link>
              <Link 
                to="/threephase" 
                className="px-6 py-2 
                  border border-[#005BAC] 
                  bg-[#005BAC] 
                  text-white 
                  rounded-md 
                  transition duration-300 
                  hover:bg-white 
                  hover:text-[#005BAC] 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-[#005BAC] 
                  focus:ring-opacity-50"
              >
                Three Phase
              </Link>
            </div>
          </div>

          <Cards2 />
          <Charts />
        </div>
      </section>
    </>
  );
}

export default Home;
